const DESKTOP_QUERY = '(min-width: 1024px)';

/**
 * Cluster-Navigation.
 */
export default () => ({
    open: false,

    init() {
        this.syncViewport();
        this.$nextTick(() => this.scrollToActive());
    },

    syncViewport() {
        this.open = window.matchMedia(DESKTOP_QUERY).matches;
    },

    scrollToActive() {
        const list = this.$refs.list;
        const active = list?.querySelector('[data-cluster-active]');

        if (!list || !active || list.scrollHeight <= list.clientHeight) {
            return;
        }

        list.scrollTop = active.offsetTop - (list.clientHeight - active.clientHeight) / 2;
    },
});
